import { SharedLocale, type SharedLocalizedString } from "../SharedLocale.js";

export const contactPathMap = {
	[SharedLocale.cs]: "kontakt",
	[SharedLocale.en]: "contact",
	[SharedLocale.pl]: "kontakt",
	[SharedLocale.sk]: "kontakt",
} satisfies SharedLocalizedString;
